// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ errorsModalIsOpen: boolean }>;

export const DispatchSetErrorsModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/SetErrorsModalIsOpen",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetErrorsModalIsOpen];

const setErrorsModalIsOpen = createHandlerChainRunner(chain, "SetErrorsModalIsOpen");
export default setErrorsModalIsOpen;
